document.addEventListener("DOMContentLoaded", function () {
  const episodes = document.querySelectorAll(".episode-swiper .swiper-slide");

  // Run swiper if there's more than 1 episode
  if (episodes.length > 1) {
    const episodeSwiper = new Swiper(".episode-swiper", {
      slidesPerView: 1.2, // mobile: show 1 + peek
      spaceBetween: 24,
      centeredSlides: true,
      grabCursor: true,
      loop: false,
      navigation: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        750: {
          slidesPerView: 2.2,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 3,
          centeredSlides: false, // prevent left gap on desktop
        },
      },
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
    const mainTitle = document.querySelector(".main-video-title");
    const mainDate = document.querySelector(".main-video-date");
    const mainDescription = document.querySelector(".main-video-description");
    const mainMedia = document.getElementById("main-deferred-media");

    const video = document.querySelector("video");
    if (video) {
    video.muted = true; // Ensure muted for autoplay compliance
    video.play().catch((error) => console.log("Autoplay prevented:", error));
    }

    const swiperContainer = document.querySelector('.episode-swiper');
    if (swiperContainer) {
        const episodes = swiperContainer.querySelectorAll(".swiper-slide");
        // Run swiper if there's more than 1 episode
        if (episodes.length > 1) {
            const episodeSwiper = new Swiper(".episode-swiper", {
                slidesPerView: 1.2, // mobile: show 1 + peek
                spaceBetween: 24,
                centeredSlides: true,
                grabCursor: true,
                loop: false,
                navigation: false,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    750: {
                        slidesPerView: 2.2,
                        centeredSlides: false,
                    },
                    1024: {
                        slidesPerView: 3,
                        centeredSlides: false, // prevent left gap on desktop
                    },
                },
            });
        }
    }

    
        if (!mainMedia) return;

    document.querySelectorAll(".episode-block").forEach((block) => {
        block.addEventListener("click", () => {
            // --- find elements we will swap ---
            const mainPosterBtn = mainMedia.querySelector(".deferred-media__poster");
            const mainTemplateEl = mainMedia.querySelector("template");
            const mainActivePlayer = mainMedia.querySelector("iframe, video"); // if video currently playing

            // episode's deferred-media (if present) and poster/template
            const episodeDeferred = block.querySelector(".deferred-media");
            const epPosterBtn = episodeDeferred 
                ? episodeDeferred.querySelector(".deferred-media__poster")
                : block.querySelector(".deferred-media__poster");
            const epTemplateEl = episodeDeferred
                ? episodeDeferred.querySelector("template")
                : block.querySelector("template");

            // --- snapshot main and episode data (use outerHTML for poster to keep srcset/picture) ---
            const mainData = {
                title: mainMedia.dataset.title || mainTitle?.textContent || "",
                date: mainMedia.dataset.date || mainDate?.textContent || "",
                description: mainMedia.dataset.description || mainDescription?.textContent || "",
                videoId: mainMedia.dataset.videoId || "",
                videoType: mainMedia.dataset.videoType || "",
                posterHTML: mainPosterBtn ? mainPosterBtn.outerHTML : "",
                templateHTML: mainTemplateEl ? mainTemplateEl.innerHTML : "",
                activePlayerHTML: mainActivePlayer ? mainActivePlayer.outerHTML : "",
                ratioPercent: mainMedia.style.getPropertyValue("--ratio-percent") || "",
            };

            const epData = {
                title: block.dataset.title || block.querySelector(".episode-title")?.textContent || "",
                date: block.dataset.date || block.querySelector(".episode-date")?.textContent || "",
                description: block.dataset.description || block.querySelector(".episode-description")?.textContent || "",
                videoId: block.dataset.videoId || "",
                videoType: block.dataset.videoType || "",
                posterHTML: epPosterBtn ? epPosterBtn.outerHTML : "",
                templateHTML: epTemplateEl ? epTemplateEl.innerHTML : "",
                // compute aspect percent for episode if block has data-aspect-ratio (you set this in Liquid)
                ratioPercent: (function () {
                    const r = parseFloat(block.dataset.aspectRatio);
                    return r ? (1 / r) * 100 + "%" : "";
                })(),
            };

            // --- update main text & datasets ---
            if (mainTitle) mainTitle.textContent = epData.title;
            if (mainDate) mainDate.textContent = epData.date;
            if (mainDescription) mainDescription.textContent = epData.description;
            mainMedia.dataset.title = epData.title;
            mainMedia.dataset.date = epData.date;
            mainMedia.dataset.description = epData.description;
            mainMedia.dataset.videoId = epData.videoId;
            mainMedia.dataset.videoType = epData.videoType;

            // --- remove any active player in main (so we can replace cleanly) ---
            if (mainActivePlayer) mainActivePlayer.remove();

            // --- replace main's poster + template with episode's poster/template ---
            let newMainInner = "";
            if (epData.posterHTML) newMainInner += epData.posterHTML;
            newMainInner += "<template>" + (epData.templateHTML || "") + "</template>";
            mainMedia.innerHTML = newMainInner;

            // update aspect ratio style on main so layout matches episode poster
            if (epData.ratioPercent) {
                mainMedia.style.setProperty("--ratio-percent", epData.ratioPercent);
            } else if (mainData.ratioPercent) {
                // if episode had no ratio but we saved main's ratio earlier, keep it (defensive)
                mainMedia.style.setProperty("--ratio-percent", mainData.ratioPercent);
            }

            // If the main had an active player (was playing), inject the episode's player immediately
            // (This will put the episode's iframe/video into the DOM and start autoplay if its markup specifies it)
            if (mainActivePlayer && epData.templateHTML) {
                // put the episode's template HTML directly into the DOM (after poster removal)
                // note: we've already removed active player and replaced innerHTML, so insert the player
                mainMedia.insertAdjacentHTML("beforeend", epData.templateHTML);
            }

            // --- update the clicked episode block to show the old main poster/template/data ---
            block.dataset.title = mainData.title;
            block.dataset.date = mainData.date;
            block.dataset.description = mainData.description;
            block.dataset.videoId = mainData.videoId;
            block.dataset.videoType = mainData.videoType;

            // find the episode's deferred-media wrapper again (it may still exist)
            const epDeferredAfter = block.querySelector(".deferred-media");
            if (epDeferredAfter) {
            let newEpInner = "";
            if (mainData.posterHTML) newEpInner += mainData.posterHTML;
            newEpInner +=
                "<template>" + (mainData.templateHTML || "") + "</template>";
            epDeferredAfter.innerHTML = newEpInner;

            // restore main's aspect percent onto the episode deferred-media
            if (mainData.ratioPercent)
                epDeferredAfter.style.setProperty(
                "--ratio-percent",
                mainData.ratioPercent
                );
            } else {
            // fallback: replace poster button if no wrapper
            const epPosterFallback = block.querySelector(".deferred-media__poster");
            if (epPosterFallback && mainData.posterHTML)
                epPosterFallback.outerHTML = mainData.posterHTML;
            }

            // update episode visible text nodes
            const epTitleNode = block.querySelector(".episode-title");
            if (epTitleNode) epTitleNode.textContent = mainData.title;
            const epDateNode = block.querySelector(".episode-date");
            if (epDateNode) epDateNode.textContent = mainData.date;
            const epDescNode = block.querySelector(".episode-description");
            if (epDescNode) epDescNode.textContent = mainData.description;

            // smooth scroll
            mainMedia.scrollIntoView({ behavior: "smooth" });
        });
    });
});
